export const actionTypes = {
  SET_HOME_LOADING_TRUE: 'SET_HOME_LOADING_TRUE',
  RESET_HOME_STATE: 'RESET_HOME_STATE'
};
